__turbopack_context__.v({
  "backButton": "CenteredModal-module__EfHEMq__backButton",
  "centered-modal-back-in": "CenteredModal-module__EfHEMq__centered-modal-back-in",
  "centered-modal-fade": "CenteredModal-module__EfHEMq__centered-modal-fade",
  "closeButton": "CenteredModal-module__EfHEMq__closeButton",
  "dialog": "CenteredModal-module__EfHEMq__dialog",
  "modal": "CenteredModal-module__EfHEMq__modal",
  "modalFitContent": "CenteredModal-module__EfHEMq__modalFitContent",
  "modalGrowToViewport": "CenteredModal-module__EfHEMq__modalGrowToViewport",
  "modalLarge": "CenteredModal-module__EfHEMq__modalLarge",
  "modalMedium": "CenteredModal-module__EfHEMq__modalMedium",
  "overlay": "CenteredModal-module__EfHEMq__overlay",
});
